// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"722":"1287d9a1","839":"318550fb","881":"3b0328c6"}[chunkId] + ".chunk.css";
};